import { combineReducers } from "redux";

import homeReducer from "./homeReducer";
import healthReducer from "./healthReducer";

export default combineReducers({
  home: homeReducer,
  health: healthReducer
});
